import type { Product } from '../types/product';

export const getProductAris = ({ products, cloudId }: { products: Product[]; cloudId: string }): string[] => {
	return products.map((product) => `ari:cloud:${product}::site/${cloudId}`);
};
